import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { CBQScenarioDTO } from "./InitCBQScenario";

export interface UpdateCBQScenarioPayload {
  title?: string;
  pdfS3Key?: string;
  estimatedMinutes?: number;
}

type UpdateCBQScenarioResponse = {
  statusCode?: number;
  error?: null | ApiError;
  data?: CBQScenarioDTO;
};

export const UpdateCBQScenario = async ({
  scenarioId,
  payload,
}: {
  scenarioId: string;
  payload: UpdateCBQScenarioPayload;
}): Promise<UpdateCBQScenarioResponse> => {
  try {
    const response = await axios.patch(
      `/admin/cbq/scenarios/${scenarioId}`,
      payload
    );
    return { data: response.data?.data ?? response.data };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};
